<nz-layout class="h-100">
  <!-- ENCABEZADO -->
  <nz-page-header [nzTitle]="nzBreadcrumb" [class.hide]="(screenService.isMobile$ | async) && !showGlobalSearch">
    <ng-template #nzBreadcrumb>
      <div class="flex-center-between">
        <nz-breadcrumb class="flex-center">
          <!--          <button style="margin-right: 6px" nz-button nzType="text" nzShape="circle" nzSize="default">-->
          <!--            <app-st-icon class="text-dark" [bold]="true" name="arrow_back"></app-st-icon>-->
          <!--          </button>-->

          @if (!(screenService.isMobile$ | async)) {
            <!--   Desktop   -->
            <ng-container>
              <nz-breadcrumb-item>
                <!--                <span class="text-label-14 text-semibold cursor-pointer">Maestros</span>-->
                <!--                 /-->
                <span>{{ maestroName }}</span>
              </nz-breadcrumb-item>
            </ng-container>
          } @else {
            <!--   Mobile   -->
              <!--            <ng-container *ngIf="(breadcrumb$ | async) as breadcrumb">-->
              <!--              &lt;!&ndash;  Si el length del breadcrumb es 3 es que se esta en el detalle de Servicios  &ndash;&gt;-->
              <!--              <app-st-icon *ngIf="breadcrumb.length === 3" style="margin-right: 5px"-->
              <!--                           [avatar]="true" [smallAvatar]="true"-->
              <!--                           [name]="gs.getServiceType(selectedService?.typeId || 0)?.icon || 'close'">-->
              <!--              </app-st-icon>-->

              <!--              <nz-breadcrumb-item>-->
              <!--                <span class="text-header-16">{{ breadcrumb[breadcrumb.length - 1].label }}</span>-->
              <!--              </nz-breadcrumb-item>-->
              <!--            </ng-container>-->
          }
        </nz-breadcrumb>
      </div>
    </ng-template>

    <nz-page-header-extra>
      <app-global-searchbar
        [ngClass]="{'hide': (screenService.isMobile$ | async) && !showGlobalSearch}"></app-global-searchbar>
    </nz-page-header-extra>
  </nz-page-header>

  <!-- CONTENEDOR PRINCIPAL -->
  <div class="maestro-wrapper" [class.gap-0]="(screenService.isMobile$ | async) &&showGlobalSearch">
    <!-- Mostrar busqueda y filtros avanzados (Mobile) -->
    <div class="mobile-search-filter">
      <button (click)="openFormDrawer()" nzShape="circle" nzSize="default" nz-button nzType="text">
        <app-st-icon [bold]="true" name="add"></app-st-icon>
      </button>
      <button (click)="toggleSearch($event)" nzShape="circle" nzSize="default" nz-button nzType="text">
        <app-st-icon [bold]="true" name="search"></app-st-icon>
      </button>
      <button (click)="toggleGlobalSearch($event)" nzShape="circle" nzSize="default" nz-button nzType="text">
        <app-st-icon [bold]="true" name="travel_explore"></app-st-icon>
      </button>
    </div>

    @if (!(screenService.isMobile$ | async)) {
      <h1>{{ maestroName }}</h1>
    }
    <div class="flex-center-between">
      <app-pocket-searchbar [class.hide]="(screenService.isMobile$ | async) && !showSearch"
                            [class.w-100]="(screenService.isMobile$ | async)"
                            [(searchValue)]="searchValue"
                            (searchEvent)="filter()"></app-pocket-searchbar>

      @if (!(screenService.isMobile$ | async)) {
        <div class="flex gap-200">
          @if (secondaryBtnText) {
            <button (click)="emitSecondaryBtnClick()"
                    class="flex-center-between" nz-button nzType="default" nzShape="round" nzSize="default">
              @if (ms.secondaryLoading$ | async) {
                <app-st-icon class="prefix" name="progress_activity"></app-st-icon>
              }
              {{ secondaryBtnText }}
            </button>
          }

          @if (permissions.create) {
            <button (click)="openFormDrawer()"
                    class="flex-center-between" nz-button nzType="primary" nzShape="round" nzSize="default">
              <app-st-icon class="prefix" name="add"></app-st-icon>
              Añadir
              <!--          Crear {{ maestroName | lowercase }}-->
            </button>
          }
        </div>
      }

    </div>

    <nz-table #table [nzData]="filteredData" [nzScroll]="{x: (screenService.isMobile$ | async) ? '350px' : 'auto'}"
              class="st-bordered">
      <tr>
        @for (column of columnsDataToShow; track column) {
          @if (column.checkboxOnTable) {
            <th [nzAlign]="column.align || 'center'" [style.width]="column.width || '50px'">
              <label nz-checkbox
                     [(ngModel)]="allSelected"
                     [nzIndeterminate]="indeterminate"
                     (ngModelChange)="onSelectAll($event)">
              </label>
            </th>
          } @else {
            @if (!column.checkbox) {
              <th [nzAlign]="column.align || null" style="white-space: nowrap; position: relative"
                  [class.sorteable-column]="column.sortable"
                  [style.width]="(screenService.isMobile$ | async) && column.widthMobile
                                ? column.widthMobile
                                : (column.width ? column.width : 'auto')">{{ column.name }}

                @if (column.sortable) {
  <app-st-th-sort
                  [sortDirection]="getColumnSortDirection(column)"
                  (sortEvent)="column.sortFn && column.sortFn()"></app-st-th-sort>
                }
              </th>
            }
          }
        }
        <th [style.width]="(screenService.isMobile$ | async) && !showDetails ? '45px' : '76px'" [nzRight]="'0px'"></th>
      </tr>
      <tbody style="width: 20px">
        @for (item of table.data; track item.id) {
          <tr>
            @for (column of columnsDataToShow; track column) {
              @if (column.optionList && column.optionList.length > 0) {
                @if (column.pathData!.type === 'icon-select') {
                  <td>
                    @if (!!item[column.pathData!.name]) {
                      <app-st-icon [bold]="true" [name]="item[column.pathData!.name]"></app-st-icon>
                    } @else {
                      <span class="color-grey-9">-</span>
                    }
                  </td>
                } @else {
                  <td [class.color-grey-9]="findOptionNameById(item[column.pathData!.name!], column.optionList!) === '-'">{{ findOptionNameById(item[column.pathData!.name!], column.optionList!) || '-' }}</td>
                }
              } @else {
                @if (column.pathData!.type! == 'date') {
                  <td [class.color-grey-9]="!deepGet(item, column.pathData!.name!)">{{ deepGet(item, column.pathData!.name!) ? ((deepGet(item, column.pathData!.name!) | date:  column.pathData?.dateFormat || "dd/MM/yyyy") | uppercase) : '-' }}</td>
                } @else if (column.pathData!.type! == 'image') {
                  <td>
                    @if (item[column.pathData!.name!]) {
                      <nz-avatar class="not-max-width" (click)="openViewImageModal(item[column.pathData!.name!])"
                                 [nzSrc]="getSafeImageUrl(item[column.pathData!.name!])"
                                 style="cursor: pointer;"></nz-avatar>
                    } @else {
                      <nz-avatar nzIcon="user"></nz-avatar>
                    }
                  </td>
                } @else if (column.pathData!.type! == 'multi-select') {
                  <td style="display: flex;flex-wrap: wrap;">
                    @if (item[column.pathData!.name!] && item[column.pathData!.name!].length > 0) {
                      @for (document of item[column.pathData!.name!]; track document) {
                        <app-doc-badget-status [document]="document"></app-doc-badget-status>
                      }
                    } @else {
                      <span class="color-grey-9">-</span>
                    }
                  </td>
                } @else if (column.pathData!.type! == 'boolean') {
                  <td>{{ item[column.pathData!.name!] ? 'Sí' : 'No' }}</td>
                } @else if (column.pathData!.type! == 'money-rate') {
                  @if (deepGet(item, column.pathData!.name!)) {
                    @if (setCurrencyData(deepGet(item, column.pathData!.name!), deepGet(item, 'isoCode'), !!column.pathData?.reverseRate); as currencyData) {
                      <td
                       >
                        <div class="flex-center gap-075" style="width: fit-content">
                          <span class="text-label-12">1 {{ currencyData.firstIso }} = </span>
                          <span class="st-badget subtle-grey"
                                style="padding: 6px 7px">{{ currencyData.rate | number: '1.0-4' }} {{ currencyData.lastIso }}</span>
                        </div>
                      </td>
                    }
                  } @else {
                    <td class="color-grey-9">-</td>
                  }
                } @else if (column.pathData!.type! == 'badge'){
                  <td>
                    <nz-badge [nzCount]="item[column.pathData!.name!]"
                              [nzStyle]="{ backgroundColor: '#EBEBEB', color: '#171717', fontWeight:'600',
                              width:'23px', height:'20px', fontSize:'10px', boxShadow:'0 0 0 1px #EBEBEB'}"
                              class="badge-table">
                    </nz-badge>
                  </td>
                } @else if (column.checkboxOnTable) {
                  <td [nzAlign]="column.align || 'center'">
                    <label nz-checkbox
                           [ngModel]="selectedIds.includes(item.id)"
                           (ngModelChange)="onSelectItem(item.id, $event)">
                    </label>
                  </td>
                } @else {
                  <td [class.color-grey-9]="!item[column.pathData!.name!]">
                    <div class="assignment-cell">
                      @if (shouldShowAssignmentWarning(item, column)) {
                        <app-st-icon
                          class="assignment-warning-icon"
                          name="warning"
                          [bold]="true"
                          [nz-tooltip]="getAssignmentRestrictionTooltip()">
                        </app-st-icon>
                      }
                      <span>{{ item[column.pathData!.name!] || '-' }}</span>
                    </div>
                  </td>
                }
              }
            }
            <td nzAlign="center" class="action-cell" [nzRight]="'0px'">
              @if (permissions.edit || permissions.delete) {
                <button nz-button nzType="text" nzShape="circle"
                        nzSize="default" nz-dropdown
                        [nzDropdownMenu]="item.isoCode !== 'USD' ? actionMenu : null" nzTrigger="click">
                  <app-st-icon name="more_vert" [bold]="true"></app-st-icon>
                </button>
              }
              @if (showDetails) {
                @if (permissions.viewDetails) {
                  <button (click)="openDetailsDrawer(item)" nz-button nzType="text"
                          nzShape="circle" nzSize="default">
                    <app-st-icon name="right_panel_open" [bold]="true"></app-st-icon>
                  </button>
                }
              }
            </td>

            <nz-dropdown-menu #actionMenu="nzDropdownMenu">
              <ul nz-menu>
                <!-- El USD no se puede editar -->
                @if (permissions.edit) {
                  <li (click)="openFormDrawer(item)" nz-menu-item>
                    <button nz-button nzType="text" nzShape="circle" nzSize="default"
                            class="flex- flex-center gap-100">
                      <app-st-icon name="edit" [bold]="true"></app-st-icon>
                      <span class="text-label-14 text-dark">Editar</span>
                    </button>
                  </li>
                }
                @if (permissions.delete) {
                  <li nz-menu-item (click)="openDeleteConfirmation(item.id)">
                    <button class="flex-center gap-100"
                            nz-button nzType="text" nzShape="circle" nzSize="default">
                      <app-st-icon name="delete" [bold]="true"></app-st-icon>
                      <span class="text-label-14 text-dark">Eliminar</span>
                    </button>
                  </li>
                }
              </ul>
            </nz-dropdown-menu>
          </tr>
        }
      </tbody>
    </nz-table>

    @if (!tableData?.length) {
      <nz-empty nzNotFoundImage="simple"></nz-empty>
    }
    <ng-template #viewImageModalTmpl>
      <div class="confirm-modal"
           style="display: flex;flex-direction: column;padding: 15px;align-items: center;justify-content: center;">
        <app-st-icon (click)="viewImageModalRef.close()" class="custom-clear" name="close"
                     style="position: absolute;top: 15px;right: 15px;cursor: pointer;"></app-st-icon>
        <img style="max-width: 300px;" src="{{tmpImage }}">
      </div>
    </ng-template>
  </div>
</nz-layout>

<app-confirmation-modal #confirmationModal (confirmed)="onDeleteConfirmed($event)"></app-confirmation-modal>








